export default __webpack_public_path__ + "static/media/Step-9-safari.958b9d66.mov";